import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestcaseComponent } from './testcase/testcase.component';
import { TestsuiteComponent } from './testsuite/testsuite.component';
import { ExecutionHistoryRoutingModule } from './execution-history.routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MastersuiteComponent } from './mastersuite/mastersuite.component';
import { SharedModule } from '@app/_shared/shared.module';
import { FilterOptionsComponent } from './filter-options/filter-options.component';
import { SharedPipeModule } from "../_pipes/shared-pipe.module";
import { NewExecutionHistoryComponent } from './new-execution-history/new-execution-history.component';

@NgModule({
  declarations: [TestcaseComponent, TestsuiteComponent, MastersuiteComponent, FilterOptionsComponent, NewExecutionHistoryComponent],
  imports: [
    CommonModule,
    ExecutionHistoryRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    SharedPipeModule
]
})
export class ExecutionHistoryModule { }
